<footer data-type="1x-footer" data-limited="true"></footer>
